var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCashDrawer = function SvgCashDrawer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.5v6H2v-6m20 0-1.5-4h-1.161m2.661 4H2m0 0 1.5-4h1.474M9 16.5h6m1.105-8.924.241-.065M7.412 9.905l.241-.065m-1.416 3.438a1.991 1.991 0 0 1-.481-.859L4.721 8.556a2 2 0 0 1 1.414-2.45l9.66-2.588a2 2 0 0 1 2.449 1.414l1.035 3.864a2 2 0 0 1-1.414 2.45l-8.186 2.193m4.253-5.281a2 2 0 1 1-3.864 1.035 2 2 0 0 1 3.864-1.035Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCashDrawer;